import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { GetAddonItems as fetchAddonItems } from "../../../../services/productService";

export default function AddonItems() {
    const [addOns, setAddOns] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getAddOns = async () => {
            try {
                const data = await fetchAddonItems();
                setAddOns(data);
            } catch (err) {
                console.error(err.message);
            } finally {
                setLoading(false);
            }
        };

        getAddOns();
    }, []);

    return (
        <section className="top-picks-section">
            <h2 className="top-picks-heading">
                Perfect Add-ons for Your Order
            </h2>

            <div className="top-picks-grid">
                {loading
                    ? Array.from({ length: 4 }).map((_, index) => (
                        <div key={index} className="top-pick-card">
                            <Skeleton height={180} />
                            <Skeleton height={20} width="70%" style={{ marginTop: 10 }} />
                        </div>
                    ))
                    : addOns.map((item) => (
                        <div key={item.id} className="top-pick-card pointer-crusser">
                            <Link to={`${item.action_url}`}>
                                <img
                                    src={item.media}
                                    alt={item.name}
                                    className="top-pick-image"
                                />
                                <p className="top-pick-title">{item.name}</p>
                            </Link>
                        </div>
                    ))}
            </div>
        </section>
    );
}